import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios'
import { Table, Icon, Button } from 'semantic-ui-react'
import { firebaseAuth, pythonApiIp, toCurrency } from '../../../../config/constants'
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import * as UiConsts from '../../../../config/UiConstants';


class ViewLargeProjectDocChangeProjectType extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            docView: []
        }
    }

    componentDidMount() {
        // console.log("spjx31 ++++++++++ ViewLargeProjectDocChangeProjectType componentDidMount");
        // console.log("spjx33: filter:" + this.props.projectId)
    }

    setSmallProjectType = () => {
        console.log("spjx3 ++++++++:setSmallProjectType");
  

        this.setProjectType("small");
    }

    setLaregProjectType = () => {
        console.log("spjx3 ++++++++:setLaregProjectType");
  

        this.setProjectType("large");
    }

    setProjectType = (projectType) => {
        console.log("spjx1 ++++++++:setProjectType");
        console.log("spjx12 projectType:" + projectType)

        this.setState({ loading: true })

        axios.post(pythonApiIp + 'setProjectType', {
            apiKey: "asdfsdf&343k",
            projectId: this.props.projectId,
            enteredBy: this.props.user.email,
            projectType: projectType
        })
            .then((response) => {
                this.setState({ loading: false })

               // console.log("gdocx1 results:" + JSON.stringify(response.data, null, 3));

                if (response.data.result) {
                   // console.log("gdocx1true.. got docs");
                    this.setState({ docView: response.data.docView })

                    this.props.reload();

                } else {
                    console.log("FAILED");
                    //  alert(response.data.message);
                }
            })
            .catch((error) => {
                this.setState({ loading: false })
                console.log("extt1:" + error);

            });
    }

    render() {


        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>
                <Button onClick={this.setLaregProjectType} color='orange'>LG</Button>
                <Button onClick={this.setSmallProjectType} color='blue'>SM</Button>
            </div>
        );
    }
}

export default ViewLargeProjectDocChangeProjectType;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/ViewLargeProjectDocChangeProjectType.js